import { useState, useEffect, useCallback } from 'react';
import { getBadges, checkBadges, type BadgeItem, type NewBadge } from '../lib/api';
import { haptic } from '../utils/haptic';

export type { BadgeItem, NewBadge };

export function useBadges() {
  const [badges, setBadges] = useState<BadgeItem[]>([]);
  const [newBadges, setNewBadges] = useState<NewBadge[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchBadges = useCallback(async () => {
    try {
      const data = await getBadges();
      setBadges(data);
    } catch {
      // ignore
    } finally {
      setLoading(false);
    }
  }, []);

  /**
   * Call after actions that might unlock badges:
   * publish project, update profile, streak increment, referral processed.
   */
  const checkForNewBadges = useCallback(async () => {
    try {
      const awarded = await checkBadges();
      if (awarded.length > 0) {
        setNewBadges(awarded);
        haptic.success();
        fetchBadges();
      }
    } catch {
      // ignore
    }
  }, [fetchBadges]);

  const dismissNewBadges = useCallback(() => {
    setNewBadges([]);
  }, []);

  useEffect(() => {
    fetchBadges();
  }, [fetchBadges]);

  return { badges, newBadges, loading, checkForNewBadges, dismissNewBadges };
}
